<template>
  <div class="registrationData" v-loading="loading">
    <div class="header">
      <div class="header_left">
        <el-radio-group v-model="type" @input="typeChange">
          <el-radio-button class="header_left_radio" label="1">门诊</el-radio-button>
          <el-radio-button class="header_left_radio" label="2">网诊</el-radio-button>
        </el-radio-group>
      </div>
      <div class="header_right">
        <DateSelect v-model="date" @change="dateChange"></DateSelect>
      </div>
    </div>
    <!-- 基础数据 -->
    <div class="card basic">
      <div class="card_header">
        <div class="card_header_left">
          <div class="card_header_title">
            <el-popover
              v-if="type === '1'"
              placement="top-start"
              popper-class="tips_popover"
              width="355"
              trigger="click">
              <div>
                <div>·预约挂号量：通过常规流程产生的挂号，含转方号</div>
                <div>·预约挂号量=待签+待诊+已诊</div>
                <div>·非预约挂号量：通过快捷开方、零售开单、转方开单、续方场景产生的挂号单</div>
              </div>
              <span slot="reference" class="el-icon-question" style="margin: 0 4px 0 0; color: #9aa3ad;"></span>
            </el-popover>
            <span>{{ type === '1' ? '门诊' : '网诊' }}号源基础数据</span>
          </div>
          <div class="card_header_date">{{ date | dateFilter }}</div>
        </div>
        <div class="card_header_right">
          <div v-show="type === '1'" class="card_header_count">合计放号量：{{totalRelease}}个，合计挂号量：{{ totalRegistration }}个</div>
        </div>
      </div>

      <div class="basic_status_list" :style="`grid-template-columns: ${statusMap.gridColumns}`">
        <template v-for="statusItem in statusMap.list">
          <div v-if="statusItem.type !== 'line'" :class="{ status_list_item: true, active: statusItem.id === statusActive }" @click="statusOn(statusItem.id)">
            <div class="status_title">{{ statusItem.name }}</div>
            <div class="status_info">
              <div class="status_info_left">
                <div class="status_info_title">挂号数(个)</div>
                <div class="status_info_num">{{ statusItem.registrationNum }}</div>
              </div>
              <div class="status_info_line"></div>
              <div class="status_info_right">
                <div class="status_info_title">金额(元)</div>
                <div class="status_info_num">{{ statusItem.price }}</div>
              </div>
            </div>
            <div v-if="![0, '0', '', null, undefined].includes(statusItem.waitPrice)" class="status_info_tips">含<span class="status_info_tips_num">{{ statusItem.waitPrice }}</span>待收</div>
          </div>

          <div v-if="statusItem.type === 'line'" class="status_list_line"></div>
        </template>
      </div>

      <div class="basic_table_header" v-if="type == 1">
        <div class="basic_table_count">
          <div v-for="(item,index) in outpatientTypeList.filter(v=>{ return v.count > 0 })" :key="item.key">
            <div v-show="item.count > 0">
              {{item.label}}<span class="basic_table_count_num">{{ item.count }}</span>个<span v-if="index != outpatientTypeList.filter(v=>{ return v.count > 0 }).length -1">，</span>
            </div>
          </div>
        </div>
      </div>

      <div class="basic_table_section">
        <el-table class="custom_table" :data="basicMap.list">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="patientName" label="患者" min-width="120"></el-table-column>
          <el-table-column prop="sex" label="性别" min-width="60">
            <template slot-scope="scope">
              <div>{{ computedDictText(scope.row.sex, sexDict) }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="age" label="年龄" min-width="80">
            <template slot-scope="scope">
              <div>{{ scope.row.age}}岁{{ scope.row.ageMth }}月</div>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="手机号码" min-width="140"></el-table-column>
          <el-table-column prop="doctorVisit" label="患者类型" min-width="80">
            <template slot-scope="scope">
              <div>{{ computedDictText(scope.row.doctorVisit, doctorVisitList) }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="号源类型" min-width="110">
            <template slot-scope="scope">
              <div>{{ type == 1 ? (scope.row.isIncrease ? `${computedDictText(scope.row.type, outpatientTypeAbbrList)}加号` : computedDictText(scope.row.type, outpatientTypeAbbrList))  : '网诊' }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="挂号费" min-width="160">
            <template slot-scope="scope">
              <div class="basic_table_price">
                <span class="basic_table_price_text">￥{{scope.row.price}} </span>
                <!-- <span class="basic_table_price_tag"></span> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="statusActive == 7" prop="schedulingTime" label="候补就诊时间" min-width="200"></el-table-column>
          <el-table-column v-if="statusActive == 7"  prop="initiateTime" label="发起候补时间" min-width="200"></el-table-column>
          <el-table-column v-if="type == 1 && [1,2,3,4,5].includes(statusActive)" prop="schedulingTime" label="预约日期" min-width="200"></el-table-column>
          <el-table-column v-if="type == 2" prop="payTime" label="开始时间" min-width="200"></el-table-column>
          <el-table-column v-if="type == 1 && [1,2,3,4,5].includes(statusActive)" prop="timeQuantumName" label="预计就诊时间" min-width="200" ></el-table-column>
          <el-table-column v-if="type == 2 && [1,4,5].includes(statusActive)" prop="completeTime" label="完成时间" min-width="200" ></el-table-column>
          <el-table-column v-if="type == 2 && [1,4,5].includes(statusActive)" prop="" label="网诊时长" min-width="200" >
            <template slot-scope="scope">
              <div>{{ computedTime(scope.row) }}</div>
            </template>
          </el-table-column>
          <el-table-column v-if="type == 1 && ![7,6].includes(statusActive)"  prop="registeredCode" label="号数" min-width="100">
             <template slot-scope="scope">
              <div>{{ scope.row.timeName }}{{ scope.row.registeredCode }}</div>
            </template>
          </el-table-column>
          <el-table-column v-if="![7].includes(statusActive)" prop="status" label="状态" align="center" min-width="100">
            <template slot-scope="scope">
              <div class="basic_table_center">
                <div class="basic_table_tag" v-if="scope.row.status == '5' && scope.row.orderStatus == '9'">关闭</div>
                <div class="basic_table_tag" v-else :style="{color:registerStatusMap[scope.row.status].color,background:registerStatusMap[scope.row.status].bgColor}">{{ type == 1 ? registerStatusMap[scope.row.status].label :registerStatusMap[scope.row.status].onlineLabel}}</div>
              </div>
            </template>
          </el-table-column>
          <div v-if="type == 1 && ![7,6].includes(statusActive)">
            <el-table-column prop="name" label="签到" align="center" min-width="80">
              <template slot-scope="scope">
                <div class="basic_table_center">
                  <span class="el-icon-check basic_table_check" :class="{checked:scope.row.signed}"></span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="就诊" align="center" min-width="80">
              <template slot-scope="scope">
                <div class="basic_table_center">
                  <span class="el-icon-check basic_table_check" :class="{checked:scope.row.seed}"></span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="收费" align="center" min-width="80">
              <template slot-scope="scope">
                <div class="basic_table_center">
                  <span class="el-icon-check basic_table_check" :class="{checked:scope.row.payed}"></span>
                </div>
              </template>
            </el-table-column>
          </div>
        </el-table>
      </div>
      <div class="basic_table_pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="basicMap.pageIndex"
          :page-size="basicMap.pageSize"
          :total="basicMap.total"
          @current-change="basicTablePageNoChange">
        </el-pagination>
      </div>
    </div>

    <div class="analyze">
      <div class="analyze_menu" :style="`width: ${type === '1' ? '238px' : '368px'}`">
        <div class="analyze_tab" :class="{'analyze_tab_active':visitType == 1}" @click="changeVisitType(1)">
          <div class="analyze_tab_title tab_title_old">回诊</div>
          <div class="analyze_tab_count">
            <span class="analyze_tab_count_num">{{ visitTypeObj.returnPatientCount || 0 }}</span>
            <span class="analyze_tab_count_unit">人</span>
          </div>
          <div class="analyze_tab_rows">
            <div class="analyze_tab_article">连续复诊<span class="analyze_tab_article_num">{{ visitTypeObj.returnContinuousVisitCount || 0 }}</span></div>
            <div class="analyze_tab_article">近30天多次看诊<span class="analyze_tab_article_num">{{ visitTypeObj.returnMultipleVisitCount || 0 }}</span></div>
          </div>
        </div>
        <div class="analyze_tab" :class="{'analyze_tab_active':visitType == 2}" @click="changeVisitType(2)">
          <div class="analyze_tab_title tab_title_new">新诊</div>
          <div class="analyze_tab_count">
            <span class="analyze_tab_count_num">{{ visitTypeObj.newPatientCount || 0 }}</span>
            <span class="analyze_tab_count_unit">人</span>
          </div>
          <div class="analyze_tab_rows">
            <div class="analyze_tab_article">转介绍<span class="analyze_tab_article_num">{{ visitTypeObj.introducePatientCount || 0 }}</span></div>
            <div class="analyze_tab_article">春堂引流<span class="analyze_tab_article_num">{{ visitTypeObj.ctAttractPatientCount || 0 }}</span></div>
            <div class="analyze_tab_article">连续复诊<span class="analyze_tab_article_num">{{ visitTypeObj.newContinuousVisitCount || 0 }}</span></div>
            <div class="analyze_tab_article">近30天多次看诊<span class="analyze_tab_article_num">{{ visitTypeObj.newMultipleVisitCount || 0 }}</span></div>
          </div>
        </div>
      </div>
      <div class="card analyze_data">
        <div class="card_header">
          <div class="card_header_left">
            <div class="card_header_title">
              <el-popover
                placement="top-start"
                popper-class="tips_popover"
                width="355"
                trigger="click">
                <div>
                  <div v-if="visitType == 1">回诊：历史有过医生看诊记录的患者</div>
                  <div v-else>新诊：历史从未有过医生看诊记录的患者</div>
                </div>
                <span slot="reference" class="el-icon-question" style="margin: 0 4px 0 0; color: #9aa3ad;"></span>
              </el-popover>
              <span>{{ visitType == 1 ? '回诊明细' : '新诊明细' }}</span>
            </div>
            <div class="card_header_date">{{ date | dateFilter }}</div>
          </div>
          <div class="card_header_right"></div>
        </div>
        <div class="analyze_table_section">
          <el-table class="custom_table" :data="patientList" height="306px">
            <el-table-column prop="patientName" label="患者" min-width="100"></el-table-column>
            <el-table-column prop="phone" label="手机号码" align="center" min-width="120"></el-table-column>
            <el-table-column v-if="visitType == 2" prop="sourceType" label="来源" align="center" min-width="120">
               <template slot-scope="scope">
                <div class="analyze_table_center">
                  <div class="analyze_table_tag" v-if="scope.row.sourceType == 1">{{ computedDictText(scope.row.sourceType,sourceTypeList) }}</div>
                  <div class="analyze_table_tag_2" v-if="scope.row.sourceType == 2">{{ computedDictText(scope.row.sourceType,sourceTypeList) }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="firstVisitTime" label="初诊时间" align="center" min-width="120">
              <template slot-scope="scope">
                <div>{{ scope.row.firstVisitTime ? computedFirstVisitTime(scope.row.firstVisitTime) : '' }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="lastVisitTime" label="上次看诊时间" align="center" min-width="120">
              <template slot-scope="scope">
                <div>{{ scope.row.lastVisitTime ? computedLastVisitTime(scope.row.lastVisitTime) : '' }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="consecutiveVisitCount" align="center" min-width="140">
              <template slot="header">
                <div>
                  <span>连续复诊次数</span>
                  <el-popover
                    placement="top-start"
                    popper-class="tips_popover"
                    width="355"
                    trigger="click">
                    <div>
                      <div>·复诊：患者在疗程内就诊（即看诊时间在“上次看诊时间+服药天数+7天”内）</div>
                      <div>·连续复诊：患者看诊钱，累计的复诊次数之和（当患者疗程外就诊时，连续复诊次数清空）</div>
                    </div>
                    <span slot="reference" class="el-icon-question" style="margin: 0 0 0 4px; color: #9aa3ad;"></span>
                  </el-popover>
                </div>
              </template>
              <template slot-scope="scope">
                <div>{{scope.row.consecutiveVisitCount || 0 }}次</div>
              </template>
            </el-table-column>
            <el-table-column prop="recentlyVisitCount" label="近30天看诊次数" align="center" min-width="140">
               <template slot-scope="scope">
                <div>{{scope.row.recentlyVisitCount || 0 }}次</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div v-if="type === '1'" class="card analyze_chart">
        <div class="card_header">
          <div class="card_header_left">
            <div class="card_header_title">门诊号源预约时间</div>
            <div class="card_header_date">{{ date | dateFilter }}</div>
          </div>
        </div>
        <div ref="analyze_chat_pie" class="analyze_chart_area"></div>
      </div>
    </div>

  </div>
</template>

<script>
  import * as echarts from "echarts/core" // 引入 echarts 核心模块
  import { PieChart } from "echarts/charts" // 引入饼状图
  import { TooltipComponent } from "echarts/components" // 引入提示框组件
  import { CanvasRenderer } from "echarts/renderers" // 引入 Canvas 渲染器
  import { registerOrder,onlineOrder,registerList,registerOnlineList,registerTime,registerVisitType,registerVisitTypeList,onlineVisitType,onlineVisitTypeList } from '@/api/doctorDataAnalysis'
  import { Utils } from '@/utils/utils'
  import { dictText,isNull } from '@/utils/validateBase'
  import { sexDict,doctorVisitList,outpatientTypeAbbrList, } from '@/utils/const'
  echarts.use([TooltipComponent, PieChart, CanvasRenderer]) // 注册必须的组件

  import DateSelect from './components/DateSelect.vue'
  export default {
    name: 'registrationData',
    components: { DateSelect },
    filters: {
      dateFilter (value) {
        if (Array.isArray(value) && value.length === 2) {
          if (value[0] === value[1]) {
            const today = new Date().Format('yyyy-MM-dd')
            if (value[0] === today) {
              return `今天${new Date(today).Format('MM.dd')}`
            }

            let tomorrowDay = new Date()
            tomorrowDay.setDate(tomorrowDay.getDate() + 1)
            tomorrowDay = tomorrowDay.Format('yyyy-MM-dd')
            if (value[0] === tomorrowDay) {
              return `明天${new Date(tomorrowDay).Format('MM.dd')}`
            }

            let afterTomorrow = new Date()
            afterTomorrow.setDate(afterTomorrow.getDate() + 2)
            afterTomorrow = afterTomorrow.Format('yyyy-MM-dd')
            if (value[0] === afterTomorrow) {
              return `后天${new Date(afterTomorrow).Format('MM.dd')}`
            }

            let yesterdayDay = new Date()
            yesterdayDay.setDate(yesterdayDay.getDate() - 1)
            yesterdayDay = yesterdayDay.Format('yyyy-MM-dd')
            if (value[0] === yesterdayDay) {
              return `昨天${new Date(yesterdayDay).Format('MM.dd')}`
            }

            let format = new Date(value[0]).Format('yyyy') === new Date().Format('yyyy') ? 'MM.dd' : 'yyyy.MM.dd'
            return `${new Date(value[0]).Format(format)}`
          } else {
            return `${new Date(value[0]).Format('yyyy.MM.dd')} - ${new Date(value[1]).Format('yyyy.MM.dd')}`
          }
        }
        return ''
      }
    },
    props: {
      doctorId: {
        type: [Number, String],
        default: ''
      }
    },
    data () {
      return {
        loading: false,
        reqNum: 0,
        type: '1',
        date: [new Date().Format('yyyy-MM-dd'), new Date().Format('yyyy-MM-dd')],
        statusActive: 1,
        totalRelease:0,
        totalRegistration: 0,
        basicMap: {
          list: [],
          pageIndex: 1,
          pageSize: 10,
          total: 0
        },
        sexDict:sexDict,
        doctorVisitList:doctorVisitList,
        outpatientTypeAbbrList:outpatientTypeAbbrList,
        statusObj:{},
        outpatientTypeList:[
          { key:'dailyCount',count:0,label:'普通号' },
          { key:'dailyIncreaseCount',count:0,label:'普通加号' },
          { key:'orderCount',count:0,label:'特约号' },
          { key:'orderIncreaseCount',count:0,label:'特约加号' },
          { key:'physicalCount',count:0,label:'理疗号' },
          { key:'physicalIncreaseCount',count:0,label:'理疗加号' },
          { key:'freeClinicCount',count:0,label:'义诊号' },
          { key:'freeIncreaseCount',count:0,label:'义诊加号' },
          { key:'transferCount',count:0,label:'转方号' },
          { key:'transferIncreaseCount',count:0,label:'转方加号' },

          { key:'fastRecipeCount',count:0,label:'快捷开方' },
          { key:'momentSaleCount',count:0,label:'零售开单' },
          { key:'tranrferSaleCount',count:0,label:'转方开单' },
          { key:'continueRecipeCount',count:0,label:'续方' },
        ],
        registerStatusMap:{
          '1':{ onlineLabel:'待诊', label:'待签',color:'#FE8F1F',bgColor:'#FFF0E1' },
          '2':{ onlineLabel:'已诊', label:'待诊',color:'#1890FF',bgColor:'#E8F4FF' },
          '3':{ onlineLabel:'已完成', label:'已诊',color:'#87919B',bgColor:'#F7F8F9' },
          '-5':{ onlineLabel:'超时', label:'超时',color:'#87919B',bgColor:'#F7F8F9' },
          '-3':{ onlineLabel:'取消', label:'已退',color:'#87919B',bgColor:'#F7F8F9' },
          '-2':{ onlineLabel:'已退', label:'停诊',color:'#87919B',bgColor:'#F7F8F9' },
          '-1':{ onlineLabel:'取消', label:'取消',color:'#87919B',bgColor:'#F7F8F9' },
          '0':{ onlineLabel:'未支付', label:'未支付',color:'#87919B',bgColor:'#F7F8F9' },
          '4':{ onlineLabel:'就诊中', label:'就诊中',color:'#FE8F1F',bgColor:'#FFF0E1' },
          '5':{ onlineLabel:'', label:'补录待收',color:'#87919B',bgColor:'#F7F8F9' },
        },
        patientList:[],
        visitTypeObj:{},
        visitType:1,
        sourceTypeList:[
          { label:'转介绍',value:1 },
          { label:'春堂引流',value:2 },
        ]
      }
    },
    computed: {
      computedTime(){
        return function(row){
          if(isNull(row.completeTime) || isNull(row.payTime) ){
            return ''
          }else{
            let time = this.$moment(row.completeTime).valueOf() - this.$moment(row.payTime).valueOf()
            const totalMinutes = Math.floor(time / (1000 * 60));
            const hours = Math.floor(totalMinutes / 60);
            const minutes = totalMinutes % 60;

            let result = '';
            if (hours > 0) result += `${hours}h`;
            if (minutes > 0) result += `${minutes}min`;
            return result
          }

        }
      },
      computedDictText(){
        return function(val,list){
          return isNull(val) ? '' : dictText(val,list)
        }
      },
      statusMap () {
        let gridColumns = ''
        let list = []

        if (this.type === '1') {
          gridColumns = '1fr auto 1fr 1fr 1fr auto 1fr 1fr 1fr'
          list = [
            {
              id: 1,
              type: 'allAppointment',
              name: '预约挂号量',
              registrationNum: 0,
              price: 0,
              waitPrice: 0
            },
            {
              id: -1,
              type: 'line'
            },
            {
              id: 2,
              type: 'staySign',
              name: '待签',
              registrationNum: 0,
              price: 0,
              waitPrice: 0
            },
            {
              id: 3,
              type: 'staySee',
              name: '待诊',
              registrationNum: 0,
              price: 0,
              waitPrice: 0
            },
            {
              id: 4,
              type: 'alreadySee',
              name: '已诊',
              registrationNum: 0,
              price: 0,
              waitPrice: 0
            },
            {
              id: -2,
              type: 'line'
            },
            {
              id: 5,
              type: 'refund',
              name: '已退',
              registrationNum: 0,
              price: 0,
              waitPrice: 0
            },
            {
              id: 7,
              type: 'standby',
              name: '候补',
              registrationNum: 0,
              price: 0,
              waitPrice: 0
            },
            {
              id: 6,
              type: 'other',
              name: '非预约挂号量',
              registrationNum: 0,
              price: 0,
              waitPrice: 0
            }
          ]
        }
        if (this.type === '2') {
          gridColumns = '1fr auto 1fr 1fr 1fr auto 1fr'
          list = [
            {
              id: 1,
              type: 'allAppointment',
              name: '总挂号量',
              registrationNum: 0,
              price: 0,
              waitPrice: 0
            },
            {
              id: -1,
              type: 'line'
            },
            {
              id: 2,
              type: 'staySee',
              name: '待诊',
              registrationNum: 0,
              price: 0,
              waitPrice: 0
            },
            {
              id: 3,
              type: 'seeing',
              name: '就诊中',
              registrationNum: 0,
              price: 0,
              waitPrice: 0
            },
            {
              id: 4,
              type: 'finished',
              name: '已结束',
              registrationNum: 0,
              price: 0,
              waitPrice: 0
            },
            {
              id: -2,
              type: 'line'
            },
            {
              id: 5,
              type: 'refund',
              name: '已退',
              registrationNum: 0,
              price: 0,
              waitPrice: 0
            }
          ]
        }
        return {
          gridColumns: gridColumns,
          list: list
        }
      },
      computedFirstVisitTime(){
       return function (date){
          let end_date = this.$moment()
          let start_date = this.$moment(date)
          if(end_date.diff(start_date, 'days') < 7){
            return '7天内'
          }else if(end_date.diff( start_date, 'days') < 30 ){
            return '30天内'
          } else{
            return date;
          }
        }
      },
      computedLastVisitTime(){
        return function(date){
          let end_date = this.$moment()
          let start_date = this.$moment(date)
          if(end_date.diff(start_date, 'days') < 3){
            return '3天前'
          }else if(end_date.diff( start_date, 'days') < 15 ){
            return '15天前'
          } else{
            return date;
          }
        }
      },
    },
    mounted () {
      // this.initChat()
      if(this.type == 1){
        this.getRegisterOrder()
        this.getList()
        this.getChartsData()
        this.getRegisterVisitType()
        this.getRegisterVisitTypeList()
      }else{
        this.onlineOrder()
        this.getOnlineList()
        this.getOnlineVisitType()
        this.getOnlineVisitTypeList()
      }
    },
    methods: {
      afterRes () {
        this.reqNum--;
        if (this.reqNum <= 0) {
          this.loading = false
          this.reqNum = 0;
        }
      },
      initChat (chartData) {
        this.$nextTick(() => {
          let chat = echarts.init(this.$refs['analyze_chat_pie'])
          const option = {
            color: ['#FE8F1F', '#2CD5E4', '#1890FF'],
            series : [
              {
                type:'pie',
                radius : ['35%', '60%'],
                itemStyle : {
                  normal : {
                    label : {
                      show : true,
                      position: 'center',
                      formatter: function (params) {
                        return `{a|号源数}\n{b|${chartData.totalCount}个}`;
                      },
                      rich: {
                        a: {
                          color: '#667182',
                          align: 'center',
                          fontSize: 14,
                          lineHeight: 24
                        },
                        b: {
                          color: '#000000',
                          align: 'center',
                          fontSize: 26,
                          lineHeight: 40
                        }
                      }
                    }
                  }
                },
                data:[
                  {value:chartData.sameDayCount, name:`当天预约${chartData.sameDayCount}个`},
                  {value:chartData.oneToThreeDaysCount, name:`提前1-3天预约${chartData.oneToThreeDaysCount}个`},
                  {value:chartData.moreThanThreeDaysCount, name:`提前3天以上预约${chartData.moreThanThreeDaysCount}个`}
                ]
              },
              {
                type:'pie',
                radius : ['35%', '60%'],
                itemStyle : {
                  normal : {
                    label : {
                      show : true,
                      textStyle: {
                        fontSize:  14
                      },
                      formatter: function (params) {
                        return `${params.name}`
                      },
                      rich: {
                        a: {
                          background: '#F7F8F9'
                        },
                        b: {
                          color: '#FE8F1F',
                          fontWeight: 'bold',
                          fontSize: 14,
                          lineHeight: 22
                        },
                        c: {
                          color: '#2CD5E4',
                          fontWeight: 'bold',
                          fontSize: 14,
                          lineHeight: 22
                        },
                        d: {
                          color: '#1890FF',
                          fontWeight: 'bold',
                          fontSize: 14,
                          lineHeight: 22
                        }
                      }
                    }
                  }
                },
                data:[
                  { value: chartData.sameDayCount, name: `当天预约{b|${chartData.sameDayCount}}个` },
                  { value: chartData.oneToThreeDaysCount, name: `提前1-3天预约{c|${chartData.oneToThreeDaysCount}}个` },
                  { value: chartData.moreThanThreeDaysCount, name: `提前3天以上预约{d|${chartData.moreThanThreeDaysCount}}个` }
                ]
              }
            ]
          }
          chat.setOption(option)
        })
      },
      statusOn (id) {
        this.basicMap.pageIndex = 1
        if (id && this.statusActive !== id) {
          this.statusActive = id
        }
        if(this.type == 1){
          this.getRegisterOrder()
          this.getList()
        }else{
          this.getOnlineOrder()
          this.getOnlineList()
        }
      },
      typeChange(val){
        this.basicMap.pageIndex = 1
        this.statusActive = 1
        if(this.type == 1){
          this.getRegisterOrder()
          this.getList()
          this.getChartsData()
          this.getRegisterVisitType()
          this.getRegisterVisitTypeList()
        }else{
          this.getOnlineOrder()
          this.getOnlineList()
          this.getOnlineVisitType()
          this.getOnlineVisitTypeList()
        }
      },
      dateChange(date){
        this.date = date
        this.basicMap.pageIndex = 1
        this.statusActive = 1
        if(this.type == 1){
           this.getRegisterOrder()
           this.getList()
           this.getChartsData()
           this.getRegisterVisitType()
           this.getRegisterVisitTypeList()
         }else{
           this.getOnlineOrder()
           this.getOnlineList()
           this.getOnlineVisitType()
           this.getOnlineVisitTypeList()
        }
      },
      async getRegisterOrder(){
        let params = {
          doctorId: this.doctorId,
          startDate: this.date[0],
          endDate: this.date[1],
        }
        this.loading = true
        this.reqNum++
        let { code, data } = await registerOrder(params)
        this.afterRes()
        if( code == 200 ){
          for (const key in data) {
            this.statusMap.list.forEach(v=>{
              if(key == v.type){
                v.registrationNum = data[key].count
                v.price = data[key].amount
                v.waitPrice = data[key].waitPay
              }
            })
          }
          this.totalRegistration = this.statusMap.list.reduce((total, item) => {
            if ([1, 6].includes(item.id)) {
              total = total + item.registrationNum
            }
            return total
          }, 0)

          this.totalRelease = data.totalRelease
          this.$forceUpdate()
        }
      },
      async getList(){
        let params = {
          doctorId: this.doctorId,
          startDate: this.date[0],
          endDate: this.date[1],
          status: this.statusActive,
          deptId: this.$session.get('deptId'),
          pageIndex: this.basicMap.pageIndex,
          pageSize: this.basicMap.pageSize,
        }
        this.loading = true
        this.reqNum++
        let {code,data,total} = await registerList(params)
        this.afterRes()
        if(code==200){
          if(this.statusActive == 7){
             this.basicMap.list = data.doctorStandbyDetailList && data.doctorStandbyDetailList.records || [],
            this.basicMap.total = data.doctorStandbyDetailList && data.doctorStandbyDetailList.total || 0
          }else{
            this.basicMap.list = data.doctorRegisterDetailList && data.doctorRegisterDetailList.records || [],
            this.basicMap.total = data.doctorRegisterDetailList && data.doctorRegisterDetailList.total || 0
          }
          for (const key in data) {
           this.outpatientTypeList.forEach(v=>{
            if(v.key == key){
              v.count = data[key]
            }
           })
          }
          this.$forceUpdate()
        }
      },
      async getOnlineList(){
        let params = {
          doctorId: this.doctorId,
          startDate: this.date[0],
          endDate: this.date[1],
          status: this.statusActive,
          deptId: this.$session.get('deptId'),
          pageIndex: this.basicMap.pageIndex,
          pageSize: this.basicMap.pageSize,
        }
        this.loading = true
        this.reqNum++
        let {code,data} = await registerOnlineList(params)
        this.afterRes()
        if(code == 200){
          this.basicMap.list = data.records || []
          this.basicMap.total = data.total || 0
        }
      },
      async getOnlineOrder(){
        let params = {
          doctorId: this.doctorId,
          startDate: this.date[0],
          endDate: this.date[1],
        }
        this.loading = true
        this.reqNum++
        let { code, data } = await onlineOrder(params)
        this.afterRes()
        if( code == 200 ){
          for (const key in data) {
            this.statusMap.list.forEach(v=>{
              if(key == v.type){
                v.registrationNum = data[key].count
                v.price = data[key].amount
                v.waitPrice = data[key].waitPay
              }
            })
          }
          this.totalRegistration = this.statusMap.list.reduce((total, item) => {
            if ([1].includes(item.id)) {
              total = total + item.registrationNum
            }
            return total
          }, 0)
          this.$forceUpdate()
        }
      },
      async getChartsData(){
        let params = {
          startDate: this.date[0],
          endDate: this.date[1],
          doctorId: this.doctorId
        }
        this.loading = true
        this.reqNum++
        let {code,data } = await registerTime(params)
        this.afterRes()
        if(code==200){
          this.initChat(data)
        }
      },
      basicTablePageNoChange(val){
        this.basicMap.pageIndex = val
        if(this.type == 1){
          this.getList()
        }else{
          this.getOnlineList()
        }
      },
      async getRegisterVisitType(){
        let params = {
          doctorId: this.doctorId,
          startDate: this.date[0],
          endDate: this.date[1],
        }
        this.visitTypeObj = {}
        this.loading = true
        this.reqNum++
        let {code,data} = await registerVisitType(params)
        this.afterRes()
        if(code == 200){
          this.visitTypeObj = data || {}
        }
      },
      async getOnlineVisitType(){
        let params = {
          doctorId: this.doctorId,
          startDate: this.date[0],
          endDate: this.date[1],
        }
        this.visitTypeObj = {}
        this.loading = true
        this.reqNum++
        let {code,data} = await onlineVisitType(params)
        this.afterRes()
        if(code == 200){
          this.visitTypeObj = data || {}
        }
      },
      changeVisitType(val){
        this.visitType = val
        this.type == 1 ? this.getRegisterVisitTypeList() : this.getOnlineVisitTypeList()
        
        try {
          const btnMap = {
            1: '回诊',
            2: '新诊'
          }
          window.$trackTool.track({ v: '1', b: 'his_000009', t: 'his_0002' }, { updateTime: new Date(window.$systemTime).Format('yyyy-MM-dd hh:mm:ss'), btnName: btnMap[val] })
        } catch (error) {}
      },
      async getRegisterVisitTypeList(){
        let params = {
          doctorId: this.doctorId,
          startDate: this.date[0],
          endDate: this.date[1],
          type: this.visitType
        }
        this.patientList = []
        this.loading = true
        this.reqNum++
        let {code,data} = await registerVisitTypeList(params)
        this.afterRes()
        if(code == 200){
          this.patientList = data || []
        }
      },
      async getOnlineVisitTypeList(){
        let params = {
          doctorId: this.doctorId,
          startDate: this.date[0],
          endDate: this.date[1],
          type: this.visitType
        }
        this.patientList = []
        this.loading = true
        this.reqNum++
        let {code,data} = await onlineVisitTypeList(params)
        this.afterRes()
        if(code == 200){
          this.patientList = data || []
        }
      },
    }
  }
</script>

<style lang="less" scoped>
  .registrationData {
    width: 100%;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .header_left_radio /deep/ .el-radio-button__inner {
    padding: 0 28px;
    height: 36px;
    line-height: 34px;
  }

  .card {
    box-sizing: border-box;
    padding: 24px;
    width: 100%;
    background-color: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 12px;
  }

  .card_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .card_header_left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .card_header_title {
    line-height: 28px;
    font-weight: bold;
    font-size: 18px;
    color: #000000;
  }

  .card_header_date {
    margin: 0 0 0 8px;
    line-height: 22px;
    font-size: 14px;
    color: #667182;
  }

  .card_header_right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .card_header_count {
    line-height: 24px;
    font-size: 16px;
    color: #000000;
  }

  .to_more {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    cursor: pointer;
  }

  .to_more_text {
    font-size: 14px;
    color: #667182;
  }

  .to_more_icon {
    margin: 0 0 0 2px;
    font-size: 14px;
    color: #667182;
  }

  .custom_table {
    width: 100%;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
  }

  .custom_table::before {
    display: none;
  }

  .custom_table /deep/ .el-table__row:last-child td {
    border-bottom: none;
  }

  .basic {
    margin: 24px 0 0 0;
  }

  .basic_status_list {
    display: grid;
    grid-template-columns: 1fr auto 1fr 1fr 1fr auto 1fr 1fr;
    column-gap: 16px;
    align-items: flex-start;
    margin: 16px 0 0 0;
    width: 100%;
  }

  .status_list_item {
    box-sizing: border-box;
    position: relative;
    z-index: 1;
    padding: 16px 16px 0;
    height: 132px;
    background-color: #E8F4FF;
    border-radius: 8px;
    cursor: pointer;
  }

  .status_list_item.active {
    background: linear-gradient( 135deg, #39A0FF 0%, #0177E5 100%);
    box-shadow: 0px 2px 8px 0px rgba(0,29,57,0.2);
  }

  .status_list_item.active::after {
    content: '\25BC';
    position: absolute;
    z-index: 1;
    bottom: -10px;
    left: 50%;
    font-size: 12px;
    color: #1283ED;
    transform: translate(-50%, 0);
  }

  .status_list_line {
    width: 1px;
    height: 132px;
    background-color: #E0E0E0;
  }

  .status_title {
    line-height: 24px;
    font-weight: bold;
    font-size: 15px;
    color: #000000;
  }

  .status_list_item.active .status_title {
    color: #FFFFFF;
  }

  .status_info {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    column-gap: 12px;
    align-items: flex-start;
    margin: 8px 0 0 0;
    width: 100%;
  }

  .status_info_left {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .status_info_right {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-end;
  }

  .status_info_line {
    margin: 34px 0 0 0;
    width: 1px;
    height: 22px;
    background-color: #E0E0E0;
  }

  .status_list_item.active .status_info_line {
    margin: 32px 0 0 0;
    height: 28px;
    background-color: rgba(219,222,226,0.5);
  }

  .status_info_title {
    line-height: 22px;
    font-size: 13px;
    color: #667182;
  }

  .status_list_item.active .status_info_title {
    color: rgba(255,255,255,0.8);
  }

  .status_info_num {
    margin: 2px 0 0 0;
    line-height: 30px;
    font-weight: bold;
    font-size: 22px;
    color: #000000;
  }

  .status_list_item.active .status_info_num {
    color: #FFFFFF;
  }

  .status_info_tips {
    line-height: 24px;
    text-align: right;
    font-size: 14px;
    color: #667182;
  }

  .status_list_item.active .status_info_tips {
    color: rgba(255,255,255,0.8);
  }

  .status_info_tips_num {
    margin: 0 2px;
    color: #000000;
  }

  .status_list_item.active .status_info_tips_num {
    color: #FFFFFF;
  }

  .basic_table_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 24px 0 0 0;
    width: 100%;
  }

  .basic_table_count {
    line-height: 24px;
    font-size: 16px;
    color: #667182;
    display: flex;
    align-items: center;
  }

  .basic_table_count_num {
    margin: 0 2px;
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .basic_table_section {
    margin: 16px 0 0 0;
    width: 100%;
  }

  .basic_table_price {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .basic_table_price_text {
    font-size: 14px;
    color: #1F2329;
  }

  .basic_table_price_tag {
    margin: 0 0 0 4px;
    font-size: 12px;
    color: #FE8F1F;
  }

  .basic_table_center {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  .basic_table_tag {
    height: 22px;
    padding: 0 8px;
    line-height: 22px;
    text-align: center;
    font-size: 12px;
    color: #87919B;
    background-color: #F7F8F9;
  }

  .basic_table_check {
    font-weight: bold;
    font-size: 18px;
    color: #DBDBDB;
  }

  .basic_table_check.checked {
    color: #29C01B;
  }
.basic_table_pagination {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 16px 0 0 0;
    width: 100%;
  }
  .analyze {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 16px 0 0 0;
    width: 100%;
  }

  .analyze_menu {
    flex-shrink: 0;
    width: 238px;
  }

  .analyze_tab {
    box-sizing: border-box;
    padding: 0 24px 12px 16px;
    width: 100%;
    background-color: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 12px;
  }
  .analyze_tab_active{
    background: linear-gradient( 180deg, #F9FCFF 0%, #D9EDFF 100%);
    box-shadow: 0px 2px 8px 0px rgba(0,29,57,0.2);
    position: relative;
  }
  .analyze_tab_active::after {
    content: '\25BC';
    position: absolute;
    z-index: 1;
    top: 50%;
    right: -10px;
    font-size: 12px;
    color: #D9EDFF;
    transform: translate(0,-50%);
    transform: rotate(-90deg);
  }

  .analyze_tab+.analyze_tab {
    margin: 16px 0 0 0;
  }

  .analyze_tab_title {
    margin: 0 0 0 -16px;
    width: 80px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: 14px;
    border-radius: 12px 0 12px 0;
  }

  .tab_title_old {
    color: #FFFFFF;
    background: linear-gradient( 139deg, #39A0FF 0%, #0177E5 100%);
  }

  .tab_title_new {
    color: #765FFF;
    background-color: #ECEAFF;
  }

  .analyze_tab_count {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
  }

  .analyze_tab_count_num {
    line-height: 30px;
    font-weight: bold;
    font-size: 22px;
    color: #000000;
  }

  .analyze_tab_count_unit {
    margin: 0 0 0 4px;
    line-height: 24px;
    font-size: 14px;
    color: #000000;
  }

  .analyze_tab_rows {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
  }

  .analyze_tab_article {
    margin: 0 16px 0 0;
    line-height: 24px;
    font-size: 14px;
    color: #667182;
  }

  .analyze_tab_article_num {
    margin: 0 0 0 2px;
    font-weight: bold;
    color: #000000;
  }

  .analyze_data {
    flex-grow: 1;
    margin: 0 0 0 8px;
    min-width: 0;
  }

  .analyze_table_section {
    margin: 16px 0 0 0;
    width: 100%;
  }

  .analyze_table_center {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  .analyze_table_tag {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 24px;
    font-size: 12px;
    color: #20CFDE;
    border: 1px solid #20CFDE;
    border-radius: 2px;
  }
  .analyze_table_tag_2 {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 24px;
    font-size: 12px;
    color: #765FFF;
    border: 1px solid #765FFF;
    border-radius: 2px;
  }

  .analyze_chart {
    flex-shrink: 0;
    margin: 0 0 0 16px;
    width: 600px;
    height: 400px;
  }

  .analyze_chart_area {
    margin: 16px 0 0 0;
    width: 100%;
    height: calc(100% - 28px - 16px);
  }
</style>